module.exports = __webpack_public_path__ + "img/1.09c6586c.jpg";